import moment from 'moment';

import {
  ACTIVATE_TEACHER_LOADING,
  ACTIVATE_TEACHER_SUCCESS,
  ACTIVATE_TEACHER_ERROR,
  USER_LOGIN_LOADING,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_ERROR,
  RESET_PASSWORD_LOADING,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  USER_LOGOUT,
  UPDATE_PROFILE_LOADING,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  REAUTHENTICATE_LOADING,
  REAUTHENTICATE_SUCCESS,
  REAUTHENTICATE_ERROR,
  PAUSE_MEMBERSHIP_LOADING,
  PAUSE_MEMBERSHIP_SUCCESS,
  PAUSE_MEMBERSHIP_ERROR,
  RESUME_MEMBERSHIP_LOADING,
  RESUME_MEMBERSHIP_SUCCESS,
  RESUME_MEMBERSHIP_ERROR,
  UPDATE_CONGRATS_STATUS,
  UPDATE_UPSELL_DATA,
  SET_BOOKING_DATA,
  REFRESH_USER_LOADING,
  REFRESH_USER_SUCCESS,
  REFRESH_USER_ERROR,
} from '../actions/userActions';
import { CREATE_STRIPE_CUSTOMER_SUCCESS } from '../actions/stripeCustomerActions';
import { CREATE_STRIPE_SUBSCRIPTION_SUCCESS } from '../actions/stripeSubscriptionActions';
import { RESERVATION_CREATED } from '../actions/reservationActions';

const INITIAL_STATE = {
  profile: {},
  token: localStorage.getItem('token'),
  error: null,
  loginStatus: 'INIT',
  passwordStatus: 'INIT',
  updateStatus: 'INIT',
  reauthenticateStatus: 'INIT',
  pauseStatus: 'INIT',
  resumeStatus: 'INIT',
  congratsStatus: 'DONE',
  bookingData: null,
  upsellData: {
    status: 'DONE',
    cycle: null,
    hours: null,
    paid: false,
  },
};

const saveData = (profile, token, idToken) => {
  if (profile) {
    const profileData = {
      email: profile.email.toLowerCase(),
      name: profile.name,
      givenName: profile.givenName,
      familyName: profile.familyName,
      activate: profile.activate,
    };

    // check if skypename is empty, undefined or null
    // if so, set it to an empty string
    if (
      (typeof profile.skypeName === 'string' && !profile.skypeName.trim()) ||
      typeof profile.skypeName === 'undefined' ||
      profile.skypeName === null
    ) {
      profileData.skypeName = '';
    } else {
      // if profile.skypename contains data, trim it and set it
      profileData.skypeName = `${profile.skypeName}`.trim();
    }

    // store a more limited profile in localStorage
    localStorage.setItem('profile', JSON.stringify(profileData));
  }

  // store jwt token
  if (token) {
    localStorage.setItem('token', token);
  }

  if (idToken) {
    localStorage.setItem('id_token', idToken);
    localStorage.setItem('id_token_time', moment().format('LLLL'));
  }
};

const removeData = () => {
  localStorage.removeItem('profile');
  localStorage.removeItem('token');
  // localStorage.removeItem('id_token');
  localStorage.removeItem('customer_id');
  localStorage.removeItem('teacher_id');
};

export default function usersReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case USER_LOGIN_LOADING:
      return {
        ...state,
        profile: {},
        token: null,
        error: null,
        loginStatus: 'LOADING',
      };
    case USER_LOGIN_SUCCESS: {
      const { account, token, idToken } = action.payload;
      saveData(account, token, idToken);
      return {
        ...state,
        profile: account,
        token,
        error: null,
        loginStatus: 'SUCCESS',
      };
    }
    case USER_LOGIN_ERROR:
      return {
        ...state,
        profile: {},
        token: null,
        error: action.payload,
        loginStatus: 'FAIL',
      };
    case ACTIVATE_TEACHER_LOADING:
      return {
        ...state,
        error: null,
        updateStatus: 'LOADING',
      };
    case ACTIVATE_TEACHER_SUCCESS:
      saveData(action.payload);
      return {
        ...state,
        profile: action.payload,
        error: null,
        updateStatus: 'SUCCESS',
      };
    case ACTIVATE_TEACHER_ERROR:
      return {
        ...state,
        error: action.payload.error,
        updateStatus: 'FAIL',
      };
    case REFRESH_USER_LOADING:
      return {
        ...state,
        error: null,
        updateStatus: 'LOADING',
      };
    case REFRESH_USER_SUCCESS:
      const { account } = action.payload;
      saveData(account);
      return {
        ...state,
        profile: account,
        error: null,
        updateStatus: 'SUCCESS',
      };
    case REFRESH_USER_ERROR:
      return {
        ...state,
        error: action.payload,
        updateStatus: 'FAIL',
      };
    case UPDATE_PROFILE_LOADING:
      return {
        ...state,
        error: null,
        updateStatus: 'LOADING',
      };
    case UPDATE_PROFILE_SUCCESS:
      saveData(action.payload);
      return {
        ...state,
        profile: action.payload,
        error: null,
        updateStatus: 'SUCCESS',
      };
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        error: action.payload,
        updateStatus: 'FAIL',
      };
    case REAUTHENTICATE_LOADING:
      return {
        ...state,
        reauthenticateStatus: 'LOADING',
      };
    case REAUTHENTICATE_SUCCESS: {
      const { account: myAccount, idToken } = action.payload;
      saveData(myAccount, null, idToken);
      return {
        ...state,
        profile: myAccount,
        error: null,
        reauthenticateStatus: 'SUCCESS',
      };
    }
    case REAUTHENTICATE_ERROR:
      return {
        ...state,
        error: action.payload,
        reauthenticateStatus: 'FAIL',
      };
    case RESET_PASSWORD_LOADING:
      return {
        ...state,
        passwordStatus: 'LOADING',
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        passwordStatus: 'SUCCESS',
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        passwordStatus: 'FAIL',
      };
    case PAUSE_MEMBERSHIP_LOADING:
      return {
        ...state,
        pauseStatus: 'LOADING',
      };
    case PAUSE_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        profile: action.payload,
        error: null,
        pauseStatus: 'SUCCESS',
      };
    case PAUSE_MEMBERSHIP_ERROR:
      return {
        ...state,
        error: action.payload,
        pauseStatus: 'FAIL',
      };
    case RESUME_MEMBERSHIP_LOADING:
      return {
        ...state,
        resumeStatus: 'LOADING',
      };
    case RESUME_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        profile: action.payload,
        error: null,
        resumeStatus: 'SUCCESS',
      };
    case RESUME_MEMBERSHIP_ERROR:
      return {
        ...state,
        error: action.payload,
        resumeStatus: 'FAIL',
      };
    case CREATE_STRIPE_CUSTOMER_SUCCESS:
      return {
        ...state,
        profile: action.payload,
      };
    case CREATE_STRIPE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        profile: action.payload.account,
        stripeCustomer: action.payload.stripeCustomer,
      };
    case UPDATE_CONGRATS_STATUS:
      return {
        ...state,
        congratsStatus: action.payload,
      };
    case UPDATE_UPSELL_DATA:
      return {
        ...state,
        upsellData: action.payload,
      };
    case USER_LOGOUT:
      removeData();
      return {
        ...INITIAL_STATE,
        token: null,
      };
    case SET_BOOKING_DATA:
      return {
        ...state,
        bookingData: action.payload,
      };
    // clear booking data when first reservation is created
    case RESERVATION_CREATED:
      return {
        ...state,
        bookingData: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js